'use es6';

import invariant from 'react-utils/invariant';
import SenderLocator from 'conversations-message-history/senders/records/SenderLocator';
import RecipientLocator from 'conversations-message-history/legacy-recipients/records/RecipientLocator';
export const senderLocatorInvariant = key => {
  invariant(key instanceof SenderLocator || key instanceof RecipientLocator, `Key must be a SenderLocator or Recipient Locator. Got ${typeof key}`);
};